import {GridActionsCellItem, GridColDef} from "@mui/x-data-grid";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import useContactsStore from "../stores/useContactsStore";
import useModalState from "../stores/useModalStore";
import {Change, status} from "../../../global/interfaces/Change";
import {v4 as uuid} from "uuid";
import usePostChangeQuery from "../../../global/queries/usePostChangeQuery";

const useGetGridColumns = () => {
    const {setCurrentContact, removeContact, getContactByName} = useContactsStore();
    const {toggleIsEditContactDialogOpen, toggleIsConfirmationDialogOpen} = useModalState();
    const query = usePostChangeQuery();

    const getColumns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            valueGetter: (params) => {
                return `${params.row.titel || ""} ${params.row.name} ${params.row.nachgestellterTitel || ''}`
            }
        },
        {field: 'email', headerName: 'E-Mail', width: 180},
        {field: 'funktion', headerName: 'Funktion', width: 130},
        {field: 'telbuero', headerName: 'Telefon', width: 150},
        {field: 'telmobil', headerName: 'Mobiltelefon', width: 180},
        {
            field: 'newsletter',
            headerName: 'Newsletter',
            width: 80,
            renderCell: (params) => {
                if (params.row.newsletter === true) {
                    return <CheckIcon color="primary"/>
                } else {
                    return "";
                }
            }
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: "Bearbeiten/Löschen",
            width: 180,
            cellClassName: 'actions',
            getActions: ({id}) => {
                return [
                    <GridActionsCellItem
                        icon={<EditIcon color="primary"/>}
                        label="Bearbeiten"
                        onClick={() => {
                            toggleIsEditContactDialogOpen();
                            setCurrentContact(id.toString());
                        }}
                    />,
                    <GridActionsCellItem
                        label="Löschen"
                        icon={<DeleteIcon color="error"/>}
                        onClick={() => {
                            setCurrentContact(id.toString());
                            console.log("Id of the contact to delete: ", id)
                            toggleIsConfirmationDialogOpen();
                        }}
                    />
                ]

            }
        }
    ];

    return getColumns;
}

export default useGetGridColumns;
